import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MD - Dermatology, Fellowship in Cosmetic Dermatology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Double Chin Reduction Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Dermatology, Fellowship in Aesthetic Medicine",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Non-Surgical Chin Contouring Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Surgical Double Chin Removal Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, Fellowship in Laser Dermatology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Kybella & Laser Chin Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MD - Dermatology, Fellowship in Cosmetic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Chin Contouring Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Dermatology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimally Invasive Chin Treatment Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Double Chin Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for double chin reduction with advanced non-surgical and surgical techniques for defined jawline.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const DoubleChinTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Double Chin Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Permanent Double Chin Removal with 95% Success Rate. Non-Surgical & Surgical Solutions for Defined Jawline.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Non-Surgical Treatment Options
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15-45</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Minutes Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-4</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Visible Results</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`<2%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Complication Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "causes", label: "Causes", icon: "🔍" },
              { id: "types", label: "Treatment Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Double Chin Treatment</span>
            </h2>
          </div>

          {/* What is Double Chin */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Double Chin (Submental Fullness)
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                A double chin, medically known as submental fullness, is a common condition characterized by 
                the accumulation of excess fat beneath the chin. This creates a layer of fat that makes the 
                neck and jawline appear less defined, often affecting facial profile and overall aesthetic appearance. 
                While often associated with weight gain, double chins can affect people of all body types.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Concerns</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Loss of jawline definition, aged appearance, difficulty with photography, 
                      and self-consciousness about profile view. Affects both men and women across age groups.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Treatment Benefits</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Enhanced facial contour, improved profile, more youthful appearance, 
                      increased confidence, and permanent fat reduction in treated area.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Causes & Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Causes & Contributing Factors
            </h3>

            <div className="row">
              {[
                {
                  title: "Genetics", 
                  description: "Family history of submental fat accumulation and specific facial bone structure",
                  details: "Often runs in families regardless of weight"
                },
                {
                  title: "Weight Gain", 
                  description: "Excess body fat distributed to submental area under the chin",
                  details: "Most common cause in overweight individuals"
                },
                {
                  title: "Aging", 
                  description: "Skin laxity and loss of elasticity causing sagging under chin",
                  details: "Natural collagen and elastin depletion"
                },
                {
                  title: "Posture", 
                  description: "Poor posture habits that weaken neck muscles and contribute to fat accumulation",
                  details: "Chronic forward head position"
                },
                {
                  title: "Diet & Lifestyle", 
                  description: "High-calorie diet, lack of exercise, and lifestyle factors affecting fat distribution",
                  details: "Modifiable risk factors"
                },
                {
                  title: "Medical Conditions", 
                  description: "Certain medications, hormonal imbalances, or medical conditions affecting fat storage",
                  details: "Requires medical evaluation"
                }
              ].map((cause, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {cause.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {cause.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {cause.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Treatment Types & Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Double Chin Treatment Options
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Kybella Injections",
                    description: "FDA-approved synthetic deoxycholic acid that destroys fat cells permanently",
                    treatment: "2-6 sessions, no downtime, natural fat elimination"
                  },
                  {
                    type: "CoolSculpting",
                    description: "Non-invasive fat freezing technology that crystallizes and eliminates fat cells",
                    treatment: "1-2 sessions, gradual results over 3 months"
                  },
                  {
                    type: "Liposuction",
                    description: "Surgical fat removal through small incisions under chin for immediate results",
                    treatment: "Single procedure, local anesthesia, quick recovery"
                  },
                  {
                    type: "Laser Lipolysis",
                    description: "Laser-assisted fat melting and skin tightening using thermal energy",
                    treatment: "Minimally invasive, local anesthesia, skin tightening benefits"
                  },
                  {
                    type: "Radiofrequency Treatment",
                    description: "Heat-based technology that reduces fat and tightens skin simultaneously",
                    treatment: "Multiple sessions, no downtime, dual benefits"
                  },
                  {
                    type: "Ultrasound Therapy",
                    description: "Focused ultrasound waves that target and destroy fat cells beneath skin",
                    treatment: "Non-invasive, precise targeting, minimal discomfort"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Treatment Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Moderate to significant submental fat under chin</li>
                      <li style={{ marginBottom: "10px" }}>Good skin elasticity for optimal results</li>
                      <li style={{ marginBottom: "10px" }}>Realistic expectations about outcomes</li>
                      <li style={{ marginBottom: "10px" }}>Good overall health with no active infections</li>
                      <li>Commitment to maintaining healthy lifestyle post-treatment</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Treatment Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Skin quality and elasticity assessment</li>
                      <li style={{ marginBottom: "10px" }}>Amount and distribution of submental fat</li>
                      <li style={{ marginBottom: "10px" }}>Medical history and current medications</li>
                      <li style={{ marginBottom: "10px" }}>Budget and treatment timeline preferences</li>
                      <li>Recovery time and downtime availability</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Treatments
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Advanced non-surgical options provide effective double chin reduction without incisions, 
                    anesthesia, or significant downtime. These treatments target fat cells while preserving 
                    surrounding tissues.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Injectable Treatments:</h6>
                    <div className="row">
                      <div className="col-12">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}><strong>Kybella:</strong> Destroys fat cells permanently with deoxycholic acid</li>
                          <li style={{ marginBottom: "8px" }}><strong>Lipolytic Injections:</strong> Alternative fat-dissolving formulations</li>
                          <li style={{ marginBottom: "8px" }}><strong>Mesotherapy:</strong> Customized cocktail injections for fat reduction</li>
                          <li style={{ marginBottom: "8px" }}><strong>Combination Therapy:</strong> Injectables with skin tightening agents</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Energy-Based Treatments:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}><strong>CoolSculpting:</strong> Cryolipolysis for controlled fat freezing</li>
                      <li style={{ marginBottom: "8px" }}><strong>Radiofrequency:</strong> Heat-based fat reduction and skin tightening</li>
                      <li style={{ marginBottom: "8px" }}><strong>Laser Therapy:</strong> Targeted laser energy for fat cell destruction</li>
                      <li><strong>Ultrasound:</strong> Focused ultrasound for precise fat layer targeting</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical & Advanced Procedures
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Chin Liposuction:</strong> Immediate fat removal with small incisions</li>
                      <li style={{ marginBottom: "10px" }}><strong>Neck Lift:</strong> Comprehensive approach for fat and skin excess</li>
                      <li style={{ marginBottom: "10px" }}><strong>Platysmaplasty:</strong> Muscle tightening with fat removal</li>
                      <li style={{ marginBottom: "10px" }}><strong>Mini Neck Lift:</strong> Limited incision approach for moderate cases</li>
                      <li><strong>Thread Lift:</strong> Minimally invasive suspension technique</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Combination Approaches:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Kybella with skin tightening treatments</li>
                      <li style={{ marginBottom: "10px" }}>Liposuction with radiofrequency skin tightening</li>
                      <li style={{ marginBottom: "10px" }}>CoolSculpting with injectable treatments</li>
                      <li style={{ marginBottom: "10px" }}>Surgical and non-surgical combination therapy</li>
                      <li>Customized multi-modal treatment plans</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>3D imaging for treatment planning and simulation</li>
                      <li style={{ marginBottom: "10px" }}>Precision fat mapping for targeted treatment</li>
                      <li>Customized treatment protocols based on anatomy</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Treatment & Results Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-7",
                    title: "Initial Treatment",
                    activities: ["Procedure completion", "Mild swelling possible", "Minimal downtime", "Normal activities resume"]
                  },
                  {
                    period: "Week 2-4",
                    title: "Early Results",
                    activities: ["Swelling resolves", "Initial improvement visible", "Follow-up assessment", "Additional sessions if needed"]
                  },
                  {
                    period: "Month 1-3",
                    title: "Progressive Improvement",
                    activities: ["Continued fat reduction", "Enhanced jawline definition", "Skin tightening effects", "Optimal results developing"]
                  },
                  {
                    period: "Month 3-6",
                    title: "Final Results",
                    activities: ["Maximum improvement achieved", "Permanent fat reduction", "Final assessment", "Maintenance planning"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-treatment Care & Maintenance
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Aftercare</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Apply cold compresses to reduce swelling if needed</li>
                      <li style={{ marginBottom: "10px" }}>Avoid strenuous exercise for 24-48 hours</li>
                      <li style={{ marginBottom: "10px" }}>Gentle massage as recommended by your provider</li>
                      <li>Attend all scheduled follow-up appointments</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Maintenance</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maintain healthy weight through balanced diet and exercise</li>
                      <li style={{ marginBottom: "10px" }}>Practice good posture to prevent recurrence</li>
                      <li style={{ marginBottom: "10px" }}>Stay hydrated and limit sodium intake</li>
                      <li>Consider maintenance treatments as recommended</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is double chin treatment?",
                  answer: "Double chin treatments are generally well-tolerated with minimal discomfort. Non-surgical treatments like Kybella may cause a stinging or burning sensation during injection that lasts a few minutes, followed by temporary swelling and numbness. CoolSculpting involves initial cold sensation that quickly numbs the area. Most patients describe the discomfort as mild to moderate and manageable without pain medication. Surgical options like liposuction use local anesthesia, so you won't feel pain during the procedure, with mild soreness during recovery that is easily managed with over-the-counter pain relievers. Your provider will discuss pain management options and ensure your comfort throughout the treatment process. Most patients find the minimal discomfort well worth the significant aesthetic improvement."
                },
                {
                  question: "How long do double chin treatment results last?",
                  answer: "The longevity of double chin treatment results depends on the specific procedure and individual factors. Kybella and surgical liposuction provide permanent results because they physically destroy or remove fat cells, which do not regenerate. However, remaining fat cells can still expand with weight gain. Energy-based treatments like CoolSculpting also provide long-lasting results as treated fat cells are eliminated. Maintenance of results requires stable weight, as significant weight gain can cause remaining fat cells in the area to enlarge. Most patients enjoy permanent improvement when they maintain their weight within 5-10 pounds of their treatment weight. The treated fat cells are gone forever, but healthy lifestyle habits are important for maintaining optimal results long-term."
                },
                {
                  question: "What is the recovery time for double chin treatments?",
                  answer: "Recovery time varies significantly by treatment type: Kybella typically involves 3-7 days of swelling and bruising, with most social activities resuming within 2-3 days; CoolSculpting has virtually no downtime, with immediate return to normal activities; Liposuction requires 3-7 days of reduced activity, with most normal activities resuming within a week and exercise after 2 weeks; Laser and radiofrequency treatments usually involve minimal to no downtime. Most non-surgical treatments allow immediate return to work and social activities, though you may experience temporary swelling or redness. Surgical options require more recovery time but provide immediate, dramatic results. Your provider will give specific post-treatment instructions based on your chosen procedure and individual response."
                },
                {
                  question: "Which double chin treatment is most effective?",
                  answer: "The most effective double chin treatment depends on your specific anatomy, goals, and preferences: Kybella is highly effective for moderate fat reduction without surgery, typically requiring 2-6 sessions; CoolSculpting works well for patients who prefer non-invasive treatment with gradual results over 3 months; Liposuction provides immediate, dramatic results for significant fat removal in one procedure; Combination approaches often yield the best outcomes for comprehensive improvement. The 'most effective' treatment is the one that best addresses your specific concerns while aligning with your lifestyle, budget, and recovery preferences. During consultation, your provider will assess your submental fat, skin quality, and medical history to recommend the most appropriate and effective treatment option for your individual needs."
                },
                {
                  question: "Can double chin treatments be combined with other procedures?",
                  answer: "Yes, double chin treatments are often combined with other aesthetic procedures for enhanced results. Common combinations include: Double chin treatment with jawline filler for enhanced contour; Kybella or liposuction with skin tightening treatments; Chin reduction with facial rejuvenation procedures; Multiple non-surgical modalities for comprehensive improvement. Combination treatments can address multiple concerns simultaneously and often provide superior results compared to single treatments. For example, combining fat reduction with skin tightening can address both excess fat and skin laxity. Your provider can create a customized treatment plan that may include multiple approaches to achieve your desired outcome most effectively. Combination treatments are tailored to your specific anatomy and goals for optimal facial harmony and natural-looking results."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Defined Jawline?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides comprehensive double chin treatments with natural-looking, permanent results.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Dermatology: <strong>080-6541-7705</strong> | Aesthetic Medicine: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default DoubleChinTreatment;